import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Popover } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { DATETIME_FORMATZ_FOR_API, DATE_FORMAT_FOR_DISPLAY } from "../../../../constants/constants";
import { VaporDatePicker } from "../../../vapor";
import { DocPreview } from "./docPreview";
import MessageNote from "./messageNote";

const TitleHeader = ({currentParams, isCreate, newDetail, setModifiedDetail, setNewDetail, setPreviewModal, einvoiceType}) => {  
  const reduxSource = useSelector(state => state.precog.invoiceDetail?.data?.source);
  const source = isCreate ? "MANUAL" : reduxSource;
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  const [isNoteVisible, setIsNoteVisible] = useState(false);

  const renderTitle = () => {    
    switch (true){
    case (newDetail?.source === "B2B") :
      return <span>
        {(currentParams?.docNumber?.visible || newDetail?.doc?.number) && <FormattedMessage id="preCog.header.document" />}
        {currentParams?.docNumber?.visible && ` n° ${newDetail?.doc?.number ? newDetail.doc.number : ""}`}
        {currentParams?.docDate?.visible && ` del ${newDetail?.doc?.date ? moment(newDetail.doc.date).format(DATE_FORMAT_FOR_DISPLAY) : ""}`}
      </span>;   
    case source === "MANUAL" || source === "DOC" :
      return <div style={{display: "flex", gap: 10, color: "var(--brand-primary-shade-dark)", fontWeight: 600}}>
        <div>Documento n°</div>
        <Input          
          className="pre-cog-detail-header-document-title-input thirtytwo"
          value={newDetail?.doc?.number ? newDetail.doc.number : undefined}
          onChange={val => {    
            setNewDetail({ ...newDetail, doc: { ...newDetail.doc, number: val.target.value } });        
            
          }}
          onBlur={() => {
            setModifiedDetail({ docNumber: newDetail?.doc?.number });           
          }}
          placeholder={"inserisci numero documento"}
          autoComplete={"off"}
        />
        <div>del</div>
        <VaporDatePicker          
          format={dateFormatList}
          className="pre-cog-detail-header-document-title-input thirtytwo"
          value={newDetail?.doc?.date ? moment(newDetail.doc.date) : null}
          onChange={value => {            
            setModifiedDetail({ docDate:  moment(value).format(DATETIME_FORMATZ_FOR_API) });
            setNewDetail({ ...newDetail, doc: { ...newDetail.doc, date: value } });
          }}
          placeholder={"inserisci data documento"}
          getPopupContainer={(trigger) => trigger.parentNode}
        />
      </div>;    
    default:
      return null;
    }
  };

  return (
    <div style={{display: "flex", alignItems: "center"}}>
      {renderTitle()}
      {source === "B2B" && !isCreate && newDetail?.doc?.id &&
        <DocPreview newDetail={newDetail} setPreviewModal={setPreviewModal} einvoiceType={einvoiceType} />
      }
      { /** al momento nei movimenti bancari non ho un documento associato quindi non mostro commenti e preview */
        newDetail?.doc?.id && newDetail?.factType !== "BANK_TRANSACTION" &&  /* Sui DOC si deve poter vedere newDetail?.factType !== "DOCUMENT" && */
              <div
                style={{ display: "flex", alignItems: "center", padding: "0 8px", cursor: "pointer" }}>
                <Popover
                  onVisibleChange={(visible) => {
                    setIsNoteVisible(visible);
                  }} visible={isNoteVisible}
                  overlayStyle={{zIndex: "9999999"}}
                  getPopupContainer={trigger => trigger.parentNode}
                  placement="bottom"
                  title={null}
                  content={<MessageNote docId={newDetail?.doc?.id} isNoteVisible={isNoteVisible} setIsNoteVisible={setIsNoteVisible} />} trigger="click">
                  <FontAwesomeIcon icon={["far", "comment-alt-lines"]} className="pre-cog-detail-header-preview"  />
                </Popover>
              </div>
      }
    </div>
  );
};

export default TitleHeader;
